<template>
  <Row type="flex" :gutter="20" align="middle" style="padding-top:15px">
    <i-col v-if="field.slug !== 'about_me' && field.type !== 'array'" :offset="4" :span="6" class="section-label m">
      {{field.label}}
    </i-col>
    <i-col :span="11">
      <i-input :class="error ? 'red-border' : ''" v-model="text" type="password" @on-change="onChange" style="width:100%">
      </i-input>
    </i-col>
    <i-col v-if="tooltip" :span="2">
      <Tooltip :content="tooltip" placement='left'>
        <Icon type="information-circled"></Icon>
      </Tooltip>
    </i-col>
  </Row>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },
    field: {
      type: Object,
      required: true
    },
    error: {
      type: Boolean
    },
    tooltip: {
      type: String
    }
  },
  data() {
    return {
      text: ""
    }
  },
  watch: {
    value: function(n, o) {
      this.text = n
    }
  },
  methods: {
    onChange(v) {
      this.$emit('input', this.text)
      this.$emit('on-change', this.text)
    }
  }
}
</script>

<style scoped>
  .section-label {
    font-size:11px;
    line-height: 20px;
    color:#aaa;
  }
  .m {
    color: #333
  }
  .red-border {
    border: #ff0000 solid 1px;
    border-radius: 5px;
  }
</style>

